import { z } from "zod"

export const HealthResponse = z.object({
  status: z.enum(["ok", "degraded"]),
  service: z.string(),
  version: z.string(),
  checks: z.object({
    database: z.enum(["ok", "error"]),
  }),
  time: z.iso.datetime(),
})
export type HealthResponse = z.infer<typeof HealthResponse>
